
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 18 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6 9c0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3-3 1.35-3 3zm1.5 0c0-.825.675-1.5 1.5-1.5s1.5.675 1.5 1.5-.675 1.5-1.5 1.5S7.5 9.825 7.5 9z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.475 23.813c.15.112.338.187.525.187a.896.896 0 00.525-.188l.057-.056C10.384 22.972 18 15.53 18 9c0-5.063-3.938-9-9-9-5.063 0-9 3.938-9 9 0 6.53 7.616 13.972 8.418 14.756l.057.056zM1.5 9c0-4.2 3.3-7.5 7.5-7.5s7.5 3.3 7.5 7.5c0 5.175-5.738 11.4-7.5 13.2C7.238 20.4 1.5 14.175 1.5 9z","fill":"currentColor"}})])
          )
        }
      }
    